import type { UserRole } from "app/UtilitiesAndConstants/UtilityFunctions/userRoleUtils";

import type { IconName } from "@similarweb/icons";

export enum ISharingModalOption {
    SHARED,
    RESTRICTED,
}

export enum ISharingModalOptionName {
    SHARED = "Shared",
    RESTRICTED = "Restricted",
}

export interface ISharingModalState {
    sharingState: ISharingModalOption;
    notification?: string;
    sharedWithUsers?: number[];
    setSharingState?: (sharingState: ISharingModalOption) => void;
    isOptionDisabled?: boolean;
    sharedWithUsersToShow?: number[];
    sharedWithInvitations?: number[];
    notifyUserIds?: number[];
}

export interface ISharingModalOptionTextBase {
    optionIndex: number;
    title: string;
    subtitle: string;
    iconName?: IconName;
    notificationDefaultContent?: string;
}

type ISharedOptioonText = ISharingModalOptionTextBase;
type IRestrictedOptionText = ISharingModalOptionTextBase;

export interface ISharingModalOptionsText {
    [ISharingModalOption.SHARED]: ISharedOptioonText;
    [ISharingModalOption.RESTRICTED]: IRestrictedOptionText;
}

export interface ISharingModalTextContainer {
    header: Omit<ISharingModalOptionTextBase, "optionIndex">;
    sharingOptionTextContainer: ISharingModalOptionsText;
}

export type ISharingModalOnSubmit = (sharing: ISharingModalState, onClose?: () => void) => void;

export interface IValidatedEmailError {
    email: string;
    message: string;
}

export enum IEmailError {
    EMAIL_INVALID = "EMAIL_INVALID",
    DIFFERENT_EMAIL_DOMAIN = "DIFFERENT_EMAIL_DOMAIN",
    DIFFERENT_ACCOUNT = "DIFFERENT_ACCOUNT",
    SAME_ACCOUNT = "SAME_ACCOUNT",
}

type IErrorTranslation = {
    [key in IEmailError]: string;
};

export const EmailErrorTranslation: IErrorTranslation = {
    [IEmailError.EMAIL_INVALID]: "dashboard.shareDashboard.modal.inviteList.error.emailInvalid",
    [IEmailError.DIFFERENT_EMAIL_DOMAIN]: "dashboard.shareDashboard.modal.inviteList.error.emailDomain",
    [IEmailError.DIFFERENT_ACCOUNT]: "dashboard.shareDashboard.modal.inviteList.error.differentAccount",
    [IEmailError.SAME_ACCOUNT]: "dashboard.shareDashboard.modal.inviteList.error.sameAccount",
};

export enum ISharingModalShareType {
    OVERWRITE_SHARING,
    NOTIFY,
}

export interface IUpdateSharingStateRequest {
    readonly dashboardId: string;
    readonly newSharingState: ISharingModalOption;
    readonly sharedWithAccounts: number[];
    readonly sharedWithUsers: number[];
    readonly sharedWithInvitations: number[];
    readonly notification: string;
    readonly notifyUserIds: number[];
    readonly shareEndPoint: string;
}

export interface IUserInfoExtended {
    id?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: UserRole;
    isInvite?: boolean;
    text?: string;
    isMyUser?: boolean;
    isValid?: boolean;
}
